<template>
    <ul class="timeline-wrapper">
        <li class="timeline-item" v-for="item in timelineList" :key="item">
            <div class="timeline-line"></div>
            <div class="timeline-icon">
                {{item.czSort}}
                <!--<span v-if="item.roleGrade=='2'" class="icon-qzx"><span class="path1"></span><span class="path2"></span></span>-->
                <!--<span v-if="item.roleGrade=='3'" class="icon-shzx"><span class="path1"></span><span class="path2"></span></span>-->
                <!--<span v-if="item.roleGrade=='4'" class="icon-sqc"><span class="path1"></span><span class="path2"></span></span>-->
                <!--<span v-if="item.roleGrade=='1'" class="icon-dot_ld"><span class="path1"></span><span class="path2"></span></span>-->
            </div>
            <div class="timeline-content">
                <component :is="item.componentName" :timeLineList="item"></component>
            </div>
        </li>
    </ul>

</template>

<script>
    import {reactive, onMounted, ref, inject,getCurrentInstance} from 'vue';
    import {timeLineToComponent} from '../../../assets/js/base.js';
    // import sqtjInformation from '@/components/WorkorderInfromation/SqtjInformation.vue';
    // import cbdbInformation from '@/components/WorkorderInfromation/CbdbInformation.vue';
    // import returnvisitInformation from '@/components/WorkorderInfromation/ReturnvisitInformation.vue';
    // import noReturnvisitInformation from '@/components/WorkorderInfromation/NoReturnvisitInformation.vue';
    // import resultExamineInformation from '@/components/WorkorderInfromation/ResultExamineInformation.vue';
    //
    // import TimeLine_PSTS from '@/components/timeLine/TimeLine_PSTS.vue';
    // import TimeLine_CJGD from '@/components/timeLine/TimeLine_CJGD.vue';
    // import TimeLine_GDQS from '@/components/timeLine/TimeLine_GDQS.vue';
    // import TimeLine_GDPS from '@/components/timeLine/TimeLine_GDPS.vue';
    // import TimeLine_GDHF from '@/components/timeLine/TimeLine_GDHF.vue';
    // import TimeLine_GDCB from '@/components/timeLine/TimeLine_GDCB.vue';
    // import TimeLine_GDDB from '@/components/timeLine/TimeLine_GDDB.vue';
    // import TimeLine_SQTH from '@/components/timeLine/TimeLine_GDTH.vue';
    // import TimeLine_TJCZJG from '@/components/timeLine/TimeLine_TJCZJG.vue';
    // import TimeLine_GDFP from '@/components/timeLine/TimeLine_GDFP.vue';
    // import TimeLine_THSH from '@/components/timeLine/TimeLine_THSH.vue';
    // import TimeLine_CZJGSH from '@/components/timeLine/TimeLine_CZJGSH.vue';
    // import TimeLine_OVER from '@/components/timeLine/TimeLine_OVER.vue';

    import TimeLine_JGSH from '@/components/timeLine/TimeLine_JGSH.vue';
    import TimeLine_JPDW from '@/components/timeLine/TimeLine_JPDW.vue';
    import TimeLine_GDFP from '@/components/timeLine/TimeLine_GDFP.vue';
    import TimeLine_GDCZ from '@/components/timeLine/TimeLine_GDCZ.vue';
    import TimeLine_DBCC from '@/components/timeLine/TimeLine_DBCC.vue';
    import TimeLine_THSH from '@/components/timeLine/TimeLine_THSH.vue';
    import TimeLine_GDQS from '@/components/timeLine/TimeLine_GDQS.vue';
    import TimeLine_GDTH from '@/components/timeLine/TimeLine_GDTH.vue';
    import TimeLine_GDDB from '@/components/timeLine/TimeLine_GDDB.vue';
    import TimeLine_CJGD from '@/components/timeLine/TimeLine_CJGD.vue';
    import TimeLine_GDGP from '@/components/timeLine/TimeLine_GDGP.vue';
    import TimeLine_GDTS from '@/components/timeLine/TimeLine_GDTS.vue';
    import TimeLine_GDGD from '@/components/timeLine/TimeLine_GDGD.vue';
    import TimeLine_CXFP from '@/components/timeLine/TimeLine_CXFP.vue';
    import TimeLine_GDBH from '@/components/timeLine/TimeLine_GDBH.vue';

    import TimeLine_GDJP from '@/components/timeLine/TimeLine_GDJP.vue';
    import TimeLine_CXFQ from '@/components/timeLine/TimeLine_CXFQ.vue';
    import TimeLine_GDCB from '@/components/timeLine/TimeLine_GDCB.vue';
    import TimeLine_GDXG from '@/components/timeLine/TimeLine_GDXG.vue';
    import TimeLine_XGLX from '@/components/timeLine/TimeLine_XGLX.vue';

    import TimeLine_HGJC from '@/components/timeLine/TimeLine_HGJC.vue';//合格检查

    export default {
        name: "Timeline",
        components:{
            // sqtjInformation,
            // cbdbInformation,
            // returnvisitInformation,
            // noReturnvisitInformation,
            // resultExamineInformation,
            // TimeLine_PSTS,
            // TimeLine_CJGD,
            // TimeLine_GDQS,
            // TimeLine_GDPS,
            // TimeLine_GDHF,
            // TimeLine_GDCB,
            // TimeLine_GDDB,
            // TimeLine_SQTH,
            // TimeLine_TJCZJG,
            // TimeLine_GDFP,
            // TimeLine_THSH,
            // TimeLine_CZJGSH,
            // TimeLine_OVER,
            // TimeLine_GDZCL
            TimeLine_GDFP,
            TimeLine_JGSH,
            TimeLine_JPDW,
            TimeLine_GDCZ,
            TimeLine_DBCC,
            TimeLine_THSH,
            TimeLine_GDQS,
            TimeLine_GDTH,
            TimeLine_GDDB,
            TimeLine_CJGD,
            TimeLine_GDGP,
            TimeLine_GDTS,
            TimeLine_GDGD,
            TimeLine_CXFP,
            TimeLine_GDBH,
            TimeLine_GDJP,
            TimeLine_CXFQ,
            TimeLine_GDCB,
            TimeLine_GDXG,
            TimeLine_XGLX,
            TimeLine_HGJC
        },
        setup() {
            let gdId = inject("gdId");
            const {proxy} = getCurrentInstance();
            let timelineList = ref([]);
            onMounted(()=>{
                timeLine();
            });
            function timeLine() {
                proxy.$axios.post("/jgfast/wgsj/selCzlc", {
                    "gdId":gdId.value
                }).then((res) => {
                    if(res.data && res.data.length){
                        res.data.map((x)=>{
                            if(x.czCzlx){
                                return x.componentName=timeLineToComponent[x.czCzlx]
                            }
                            // else if(x.formKey = "OVER"){
                            //     return x.componentName=timeLineToComponent[x.formKey]
                            // }
                        })
                        timelineList.value = res.data;

                    }else{
                        timelineList.value=[]
                    }
                });
            }
            return {
                timelineList,
                timeLine
            }
        }
    }
</script>

<style scoped lang="less">
    .timeline-wrapper {
        .timeline-item {
            position: relative;
            padding-bottom: 12px;
            padding-left: 72px;
            &:nth-child(n+2) {
                .timeline-line {
                    height: 100%;
                    top:0;
                }
            }
            &:last-child {
                .timeline-line {
                    height: 16px;
                }
            }
            &:nth-child(2n){
                .timeline-content{
                    background: #F4F7FF;
                }

            }
            /*&:first-child{*/
                /*.timeline-content{*/
                    /*background: #FCF6EC;*/
                /*}*/
            /*}*/
        }
        .timeline-content {
            width: 100%;
            /*height: 84px;*/
            background: #FFFFFF;
            border: 1px solid #DDE0F1;
            border-radius: 4px;
            box-shadow: 0px 0px 8px rgba(92, 95, 204, 0.08), 0px 4px 12px rgba(92, 95, 204, 0.07), 0px 4px 16px 2px rgba(92, 95, 204, 0.06);
        }
        .timeline-icon {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            color: white;
            z-index: 5;
            text-align: center;
            line-height: 24px;
            background-color: #4e62cc;
            left: 16px;
            top: 16px;
            span{
                font-size: 24px;
            }
        }
        .timeline-line {
            position: absolute;
            width: 1px;
            height: calc(100% - 16px);
            top: 16px;
            left: 28px;
            border-left: 1px dashed #7A869A;

        }
    }

</style>
